import React from "react";
import PropTypes from 'prop-types';

const styles = {
  unselectedTile: {
    width: 160,
    height: 120,
  },
  selectedTile: {
    width: 170,
    height: 130,
  },
  position: {
    topLeft: {
      true: {
        left: 30,
        top: 215,
      },
      false: {
        left: 40,
        top: 225,
      }
    },
    topRight: {
      true: {
        left: 220,
        top: 215,
      },
      false: {
        left: 220,
        top: 225,
      }
    },
    botLeft: {
      true: {
        left: 30,
        top: 365,
      },
      false: {
        left: 40,
        top: 365,
      }
    },
    botRight: {
      true: {
        left: 220,
        top: 365,
      },
      false: {
        left: 220,
        top: 365,
      }
    },
  },
  unselectedStatusTile: {
    width: 136,
    height: 70,
  },
  selectedStatusTile: {
    width: 146,
    height: 80,
  },
  unselectedDeviceOffline: {
    fontSize: 23,
    lineHeight: '25px',
    color: '#D22D3c',
  },
  selectedDeviceOffline: {
    fontSize: 25,
    lineHeight: '30px',
    color: '#D22D3c',
  },
}

class ButtomTile extends React.PureComponent {
  render() {
    const { title, data, isSelected, onPress, id, position, backgroundColor, deviceOffline } = this.props;
    const combineStyle = {...styles.position[position][isSelected], ...(isSelected ? styles.selectedTile : styles.unselectedTile)};
    const additionalFontStyle = {
      ...(deviceOffline && isSelected ? styles.selectedDeviceOffline : {}),
      ...(deviceOffline && !isSelected ? styles.unselectedDeviceOffline : {}),
    };
    return(
      <div
        className='component-buttomTile'
        style={{ ...combineStyle, ...(backgroundColor && { backgroundColor: backgroundColor })}}
        onClick={() => onPress(id)}
      >
        <div className='title'>
          {title}
        </div>
        <div
          className='statusContainer'
          style={{
            ...(isSelected ? styles.selectedStatusTile : styles.unselectedStatusTile ),
            ...(backgroundColor && { color: backgroundColor }),
            ...additionalFontStyle,
          }}
          dangerouslySetInnerHTML={{__html: data}}
        >
        </div>
      </div>
    )
  }
}

ButtomTile.defaultProps = {
    onPress: null,
    deviceOffline: false,
    isSelected: false,
};

ButtomTile.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  backgroundColor: PropTypes.string.isRequired,
  data: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  position: PropTypes.oneOf([
    'topLeft', 'topRight',
    'botLeft', 'botRight',
  ]).isRequired,
  isSelected: PropTypes.bool,
  deviceOffline: PropTypes.bool,

  onPress: PropTypes.func,
};

export default ButtomTile;
